import { render, staticRenderFns } from "./PageBuilderFeatureWidget.vue?vue&type=template&id=2af18ecb&scoped=true"
import script from "./PageBuilderFeatureWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderFeatureWidget.vue?vue&type=script&lang=js"
import style0 from "./PageBuilderFeatureWidget.vue?vue&type=style&index=0&id=2af18ecb&prod&lang=scss"
import style1 from "./PageBuilderFeatureWidget.vue?vue&type=style&index=1&id=2af18ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af18ecb",
  null
  
)

export default component.exports